import { render, staticRenderFns } from "./msw-app-footer.vue?vue&type=template&id=6150af7c&scoped=true&"
import script from "./msw-app-footer.vue?vue&type=script&lang=ts&"
export * from "./msw-app-footer.vue?vue&type=script&lang=ts&"
import style0 from "./msw-app-footer.vue?vue&type=style&index=0&id=6150af7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150af7c",
  null
  
)

export default component.exports